import { ShippingLabelFormat } from '@/model';
import { decodeBinaryErrorResponse } from '@/util/RestErrorUtil';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'batch/shipments';

export class ShipmentBatchDocumentController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async generateBatchBol(shipmentIds: Array<number>): Promise<Blob> {
    const response = await this.http.get<Blob>(`${shipmentIds}/document/bol`, {
      responseType: 'arraybuffer',
    });

    const contentType = response.headers['content-type'];
    return new Blob([response.data], { type: contentType });
  }

  async generateBatchShippingLabels(
    shipmentIds: Array<number>,
    type: string,
    format: ShippingLabelFormat = ShippingLabelFormat.PDF,
  ): Promise<Blob> {
    const response = await this.http
      .get<Blob>(`${shipmentIds}/document/shipping-label/${type}`, {
        responseType: 'arraybuffer',
        params: {
          format: format === ShippingLabelFormat.ZPL ? format : undefined,
        },
      })
      .catch(async (e: unknown) => {
        // Surface the JSON validation error (e.g. ZPL for a non-4x6 template) instead of raw bytes.
        await decodeBinaryErrorResponse(e);
        throw e;
      });

    const contentType = response.headers['content-type'];
    return new Blob([response.data], { type: contentType });
  }
}
